<div class="employee-details-form-container"  fxLayout="column" fxLayoutGap="15px"   >

  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="sendForm()"     mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px" style=" top: 55px;">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card  *ngIf="user ">
            <div fxLayout="row">
              <h3>Dane pracownika</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Imię" [value]="user.firstName"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Nazwisko" [value]="user.lastName"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" style="padding-bottom: 15px">
              <div fxFlex="50">
                <app-detail header="Numer telefonu" [value]="user.phone | phone"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Adres email" [value]="user.email"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-datepicker
                  label="Data zatrudnienia od"
                  placeholder="2000-01-01"
                  [required]="true"
                  [control]="employmentAtControl"
                ></app-datepicker>
              </div>
              <div fxFlex="100">
                <app-datepicker
                  label="Data zatrudnienia do"
                  placeholder="2000-01-01"
                  [required]="false"
                  [control]="employmentToControl"
                ></app-datepicker>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-dict
                  [label]="'Wymiar etatu'" [dictType]="'working_hours'"
                  [control]="workingHoursControl"
                  [required]="true"
                  [multiple]="false"
                ></app-dict>
              </div>

            </div>

          </mat-card>
        </div>
      </div>
    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card *ngIf="currentLeave">
            <div fxLayout="row">
              <h3>Dane urlopu bieżące</h3>
            </div>

            <div fxLayout="row">
              <h3>{{ currentLeave.year }}</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" >
              <div fxFlex="50">
                  <mat-form-field class="partners-add-input" fxFlex="100" >
                    <mat-label>Wymiar urlopu</mat-label>
                    <input matInput
                           placeholder="Liczba dni"
                           name=""
                           type="number"
                           [min]="0"
                           [step]="1"
                           [required]="false"
                           [formControl]="dayToUseControl"
                    >
                  </mat-form-field>
              </div>
              <div fxFlex="50">
                <mat-form-field class="partners-add-input" fxFlex="100" >
                  <mat-label>Liczba dni urlopowych zaległych</mat-label>
                  <input matInput
                         placeholder="Liczba dni"
                         name=""
                         type="number"
                         [min]="0"
                         [step]="1"
                         [required]="false"
                         [formControl]="overdueLeaveControl"
                  >
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" >
              <div fxFlex="50">
                <mat-form-field class="partners-add-input" fxFlex="100" >
                  <mat-label>Liczba dni urlopowych opieka na dziecko</mat-label>
                  <input matInput
                         placeholder="Liczba dni"
                         name=""
                         type="number"
                         [min]="0"
                         [max]="1"
                         [step]="1"
                         [required]="false"
                         [formControl]="childcareLeaveToUseControl"
                  >
                </mat-form-field>
              </div>
              <div fxFlex="50">
                <mat-form-field class="partners-add-input" fxFlex="100" >
                  <mat-label>Liczba dni do odbioru</mat-label>
                  <input matInput
                         placeholder="Liczba dni"
                         name=""
                         type="number"
                         [min]="0"
                         [step]="1"
                         [required]="false"
                         [formControl]="receptionDayToUseControl"
                  >
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>

  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="sendForm()"     mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>


